export default {
    name: 'faq',
    title: 'FAQ Page',
    type: 'document',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'string'
        },
        {
            name: 'subtitle',
            title: 'Subtitle',
            type: 'text'
        },
        {
            name: 'faqLinks',
            title: 'FAQ Navigation Links',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'id',
                            title: 'ID',
                            type: 'string'
                        },
                        {
                            name: 'name',
                            title: 'Name',
                            type: 'string'
                        }
                    ]
                }
            ]
        },
        {
            name: 'faqGroups',
            title: 'FAQ Groups',
            type: 'array',
            of: [
                {
                    type: 'object',
                    fields: [
                        {
                            name: 'title',
                            title: 'Group Title',
                            type: 'string'
                        },
                        {
                            name: 'faqs',
                            title: 'FAQs',
                            type: 'array',
                            of: [
                                {
                                    type: 'object',
                                    fields: [
                                        {
                                            name: 'id',
                                            title: 'ID',
                                            type: 'string'
                                        },
                                        {
                                            name: 'title',
                                            title: 'Question',
                                            type: 'string'
                                        },
                                        {
                                            name: 'details',
                                            title: 'Answer',
                                            type: 'array',
                                            of: [{ type: 'block' }]
                                        },
                                        {
                                            name: 'sectionID',
                                            title: 'Section ID',
                                            type: 'string'
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
} 